"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var noTextChildNodes = ['br', 'col', 'colgroup', 'dl', 'hr', 'iframe', 'img', 'input', 'link', 'menuitem', 'meta', 'ol', 'param', 'select', 'table', 'tbody', 'tfoot', 'thead', 'tr', 'ul', 'wbr'];
var _default = noTextChildNodes;
exports.default = _default;